import React from 'react';
import { Link } from 'react-router-dom';

export const RiskDisclaimer: React.FC = () => (
  <div
    role="note"
    style={{
      marginTop: '1.5rem',
      padding: '0.75rem 1rem',
      borderTop: '1px solid rgba(148,163,184,0.25)',
      color: '#94a3b8',
      fontSize: '0.8rem',
      lineHeight: 1.5,
      textAlign: 'center',
      overflowWrap: 'anywhere',
    }}
  >
    This is not investment advice. Trading options involves substantial risk. See our{' '}
    <Link to="/terms" style={{ color: '#cbd5e1', textDecoration: 'underline' }}>terms</Link>.
  </div>
);

export default RiskDisclaimer;
